<form class="form-horizontal form-box"  [formGroup]="form" (submit)="create_new_team()">
    <h4 class="form-box-header">Create a new team within {{organization?.name}}</h4>
    <div class="form-box-content">

        <div class="form-group row pt-4 pb-3">
            <label class="col-form-label col-md-2" for="team_name">{{'teamName' | translate}}</label>
            <div class="col-md-3">
                <input type="text" id="team_name" name="team_name" [formControl]="teamNameCtrl" class="form-control" required/>
            </div>
        </div>

        <div class="form-group row py-3">
            <div class="col-md-2"></div>
            <div class="col-md-3">
                <button class="btn btn-primary" type="submit" [disabled]="teamNameCtrl.invalid"><i class="far fa-check"></i>&nbsp;Create the team</button>
            </div>
        </div>

        @if(alert.show){
        <div class="row">
            <div class="col-md-7">
                <div class="alert mb-0 {{alert.style}}">{{alert.message}}</div>
            </div>
        </div>
        }
    </div>
</form>